/**
 * Plan prices shown until the server has a saved price for a category (keeps new
 * categories visible on Pricing, dashboards and checkout). Mirrors DEFAULT_PRICING_CATEGORIES
 * in backend/server.py — the server's saved prices always win.
 */
export const DEFAULT_PRICING = {
  categories: {
    banquet_hall: { "6m": 4999, "12m": 8999 },
    lawn: { "6m": 5999, "12m": 10999 },
    catering: { "6m": 3999, "12m": 6999 },
    hotel_banquet: { "6m": 7999, "12m": 13999 },
    decoration: { "6m": 2999, "12m": 4999 },
    photography: { "6m": 3499, "12m": 5999 },
    anchor: { "6m": 2499, "12m": 4499 },
    musician: { "6m": 2499, "12m": 4499 },
    combo_all: { "6m": 17999, "12m": 29999 },
  },
  premium_slot: { "6m": 9999, "12m": 17999 },
  discount_12m_pct: 10,
};

export function withDefaults(p) {
  const src = p && typeof p === "object" ? p : {};
  const cats = { ...DEFAULT_PRICING.categories };
  Object.entries(src.categories || {}).forEach(([k, v]) => { if (v && (Number(v["6m"]) || Number(v["12m"]))) cats[k] = v; });
  return { ...DEFAULT_PRICING, ...src, categories: cats, premium_slot: src.premium_slot || DEFAULT_PRICING.premium_slot };
}
